import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import api from '../../services/api'
import toast from 'react-hot-toast'
import { BookOpen, Users, ChevronRight } from 'lucide-react'
import LoadingSpinner from '../../components/LoadingSpinner'

export default function MyCourses() {
  const [courses, setCourses] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchCourses()
  }, [])

  const fetchCourses = async () => {
    try {
      const { data } = await api.get('/trainers/courses')
      setCourses(data)
    } catch (error) {
      toast.error('Failed to load courses')
    } finally {
      setLoading(false)
    }
  }

  if (loading) return <LoadingSpinner label="Loading courses" />

  return (
    <div className="space-y-8">
      <div className="cinema-page-header">
        <div>
          <span className="cinema-label block mb-0.5">Trainer Portal</span>
          <h1 className="font-display text-xl text-white font-light">My Courses</h1>
          <p className="font-sans text-xs sm:text-sm text-cinema-muted mt-2">
            Open a course to access Class Control and Trainer Copilot.
          </p>
        </div>
      </div>

      {courses.length === 0 ? (
        <div className="cinema-empty">
          <BookOpen size={36} className="mx-auto mb-4 text-cinema-muted/20" />
          <p className="font-sans text-sm text-cinema-muted">No courses assigned yet</p>
        </div>
      ) : (
        <div className="cinema-list">
          {courses.map((course) => (
            <Link
              key={course.id}
              to={`/trainer/courses/${course.id}`}
              className="cinema-list-row group"
            >
              {course.thumbnail ? (
                <img
                  src={course.thumbnail}
                  alt={`${course.title} - ${course.course_code}`}
                  className="w-14 h-14 object-cover rounded-sm flex-shrink-0"
                  loading="lazy"
                  decoding="async"
                />
              ) : (
                <div className="w-14 h-14 flex items-center justify-center bg-cinema-glow/5 rounded-sm flex-shrink-0">
                  <BookOpen size={20} className="text-cinema-glow/30" />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5">
                  <p className="font-sans text-base text-white font-medium truncate">{course.title}</p>
                  <span className="px-2.5 py-0.5 bg-cinema-glow/10 text-cinema-glow border border-cinema-glow/20 text-xs font-sans font-medium shrink-0">
                    {course.course_code}
                  </span>
                </div>
                {course.description && (
                  <p className="font-sans text-xs sm:text-sm text-cinema-muted line-clamp-1">{course.description}</p>
                )}
                <span className="flex items-center gap-1.5 font-sans text-xs sm:text-sm text-cinema-muted mt-1.5 font-medium">
                  <Users size={13} /> {course.enrolled_students || 0} students
                </span>
              </div>
              <ChevronRight size={16} className="text-cinema-muted/40 group-hover:text-cinema-glow flex-shrink-0 transition-colors" />
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
